<dialog open>
  <h2>Tasques del dia</h2>
  <mat-list>
    <mat-list-item *ngFor="let task of taskList; let last = last;" [formGroup]="tasksForm[task.id]">
      <input  placeholder="Descripció"
        [formControlName]="'description'"/>
      <input  type="number" min="0" max="24" step="0.1" placeholder="Hores" style="width:40px"
        [formControlName]="'hours'"/>
      <button style="margin-left:0; margin-right: 0" *ngIf="last"  md-icon-button (click)="requestUpdate('ADD', task.id)">
        <mat-icon md-tooltip="Afegeix">add</mat-icon>
      </button>
      <button style="margin-left: auto; margin-right: 0" *ngIf="!last" md-icon-button (click)="requestUpdate('UPDATE', task.id)">
        <mat-icon md-tooltip="Desa">save</mat-icon>
      </button>
      <button style="margin-left:0; margin-right: 0" *ngIf="!last"  md-icon-button (click)="requestUpdate('REMOVE', task.id)">
        <mat-icon md-tooltip="Esborra">delete</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
  <button md-button style="margin-left: auto; margin-right: 0" *ngIf="!last"  (click)="hide()">
    Tanca
  </button>
</dialog>
